export const ACCOMMODATION_STATUS = {
  NEW_RESTRICTIONS_RECEIVED: {
    id: 16,
    status: "New Restrictions Received",
  },
  ALTERNATIVE_PLACEMENT_RECOMMENDED: {
    id: 17,
    status: "Alternative Placement Recommended",
  },
};
